import CreditNotesMassiveUpload from './containers/CreditNotesMassiveUpload';

export default CreditNotesMassiveUpload;
